module.exports = __webpack_public_path__ + "img/kv-start.39c74ec5.png";